import { fetchData } from './fetch';
import API from './api';

export function getEnterpriseInfo() {
    return fetchData(API.GET_ENTERPRISE_INFO.url, API.GET_ENTERPRISE_INFO.type, {});
}
